export default __webpack_public_path__ + "static/media/rolls.6b58a61a.png";